
import Throttle from '../utilities/throttle.js';


/**
 * a function that ensures all slides within a carousel are equal height.
 * This is built around the Bootstrap carousels, and uses their class names
 * during functionality
 */
(function(window, jQuery) {
  var $window = jQuery(window);

  var EqualHeightCarousel = function(element) {
    this.element = element;

    this.matchHeight = this.matchHeight.bind(this);
  };
  EqualHeightCarousel.prototype.initialise = function() {
    var slides = this.element.find('.carousel-item');
    this.slides = [];
    for (var i = 0; i < slides.length; i++) {
      this.slides.push(jQuery(slides[i]));
    }

    // run the script initially, and whenever the screen size changes
    this.matchHeight();
    $window.on('resize', Throttle(this.matchHeight, 200));
  };
  /**
   * Ensure all slides are of equal height
   */
  EqualHeightCarousel.prototype.matchHeight = function() {
    var max = 0;
    var slideContents = [];

    for (var i = 0; i < this.slides.length; i++) {
      var slide = this.slides[i];

      var content = slide.children();
      slideContents.push(content);

      var active = false;
      if (! slide.hasClass('active')) {
        active = true;
        slide.addClass('active');
      }

      content.css('height', '');
      var height = content.outerHeight();
      if (height > max) {
        max = height;
      }

      if (active) {
        slide.removeClass('active');
      }
    }

    if (max) {
      for (var i = 0; i < slideContents.length; i++) {
        slideContents[i].css('height', max);
      }
    }
  };


  $window.on('load', function() {
    var carousels = jQuery('[data-cs-carousel-equal-height]');

    if (carousels) {
      for (var i = 0; i < carousels.length; i++) {
        var item = jQuery(carousels[i]);
        var block = new EqualHeightCarousel(item);
        block.initialise();
      }
    }
  });
})(window, jQuery);

